import React, { Component } from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";

import { Box } from "reflexbox";
import { Query } from "react-apollo";

import MenuPanel from "./_MenuPanel";
import { signOutAction } from "../../actions/auth_actions";
import { withRouter } from "react-router-dom";
import Profile from "./_Profile";
import { ActionButton } from "office-ui-fabric-react/lib/Button";
import Forms from "../../common/Forms";
import Reports from "../Reports";

class Toolbar extends Component {
  render() {
    const { authenticated, role } = this.props;

    return (
      <div>
        {authenticated ? (
          <Query query={COUNT_ORDERS}>
            {({ loading, error, data }) => {
              if (loading) return "Loading...";
              if (error) {
                this.props.signOut;
              }
              return (
                <Box
                  flex
                  justify="space-between"
                  style={{
                    backgroundColor: "#112e51",
                    color: "#C6E0FF",
                    height: "50px"
                  }}
                >
                  <Box flex align="center">
                    {role !== "seller" && (
                      <Box>
                        <MenuPanel data={data} />
                      </Box>
                    )}
                    <Box ml={1}>FLORALOGIC APP ></Box>
                    <Box ml={1}>
                      {this.props.location.pathname.slice(1).toUpperCase()}
                    </Box>

                    <Box ml={4}>
                      {data &&
                        data.countOrders > 0 &&
                        `You have ${data.countOrders} new orders`}
                    </Box>
                  </Box>
                  <Box>
                    <Profile {...this.props} />
                  </Box>
                </Box>
              );
            }}
          </Query>
        ) : (
          <dev></dev>

          // <Box
          //   flex
          //   style={{ height: "50px", backgroundColor: "black" }}
          //   align="center"
          // >
          //   <Box>
          //     <ActionButton
          //       style={{ color: "white" }}
          //       iconProps={{
          //         iconName: "home",
          //         style: {
          //           color: "white"
          //         }
          //       }}
          //       text="Home"
          //       onClick={() => this.props.history.push("/")}
          //     />
          //   </Box>
          //    <Box>
          //     <ActionButton
          //       style={{ color: "white" }}
          //       iconProps={{
          //         iconName: "BIDashboard",
          //         style: {
          //           color: "white"
          //         }
          //       }}
          //       text="Services"
          //       onClick={() => this.props.history.push("/services")}
          //     />
          //   </Box>
          //   <Box>
          //     <ActionButton
          //       style={{ color: "white" }}
          //       iconProps={{
          //         iconName: "Phone",
          //         style: {
          //           color: "white"
          //         }
          //       }}
          //       text="Contact"
          //       onClick={() => this.props.history.push("/contacts")}
          //     />
          //   </Box> 
          //   <Box>
          //     <ActionButton
          //       style={{ color: "white" }}
          //       iconProps={{
          //         iconName: "unlock",
          //         style: {
          //           color: "white"
          //         }
          //       }}
          //       text="Login"
          //       onClick={() => this.props.history.push("/login")}
          //     />
          //   </Box>
          // </Box>
        )}
        <Forms />
        <Reports />
      </div>
    );
  }
}

const COUNT_ORDERS = gql`
  query countOrders {
    countOrders
  }
`;

export default withRouter(
  connect(state => state.auth, {
    signOut: signOutAction
  })(Toolbar)
);



// WEBPACK FOOTER //
// ./src/views/App/_Toolbar.js